// ** React Imports
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ** Store & Actions
import { useSelector, useDispatch } from 'react-redux';

// ** Third Party Components
import classnames from 'classnames';
import { ArrowUp } from 'react-feather';

// ** Reactstrap Imports
import { Button } from 'reactstrap';

// ** Configs
import themeConfig from '@configs/themeConfig';

// ** Custom Components
import ScrollToTop from '@components/scrolltop';
import FooterComponent from './components/footer';

// ** Custom Hooks
import { useFooterType } from '@hooks/useFooterType';

// ** Styles
import '@styles/base/core/menu/menu-types/vertical-menu.scss';
import '@styles/base/core/menu/menu-types/vertical-overlay-menu.scss';

// Import library
import * as API from '../../lib/useActions';
import TopMobileNav from '../../layouts/components/navbar/client/TopMobileNav';
import ClientNavbar from '../../layouts/components/navbar/client/ClientNavbar';
import { isMobile } from 'react-device-detect';
import BottomMobileNav from '../../layouts/components/navbar/client/BottomMobileNav';
import { getOrganizationData } from '../../utility/Utils';
import {colorDeepOrLightDetector} from "../../utility/helpers/colorDeepOrLightDetector";
import {lightenColorToRgba} from "../../utility/helpers/lightenColorToRgba";

const VerticalLayout = (props) => {
  // ** Props
  const { footer, children } = props;

  // auth token validate
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.auth);
  const {isOpenChat, isOpenBubbleChat , isOpenDmChat , isOpenDmBubbleChat} = useSelector((state) => state.socialCommunity);
   const organization = getOrganizationData();
   const themeData = JSON.parse(localStorage.getItem('themeData'));

  useEffect(() => {
    if (userData?.accessToken) {
      // if token available then validate token
      dispatch(API.validateToken({ token: userData?.accessToken }));
    }
    return () => {
      //
    };
  }, [userData, dispatch]);
  // validate token

  // ************************************

  // ** Hooks
  const { footerType, setFooterType } = useFooterType();

  // ** States
  const [isMounted, setIsMounted] = useState(false);
  const [menuVisibility, setMenuVisibility] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isTabletView, setIsTabletView] = useState(false);
  const [scrolling, setScrolling] = useState(false);

  // ** Update Window Width
  const handleWindowWidth = () => {
    setWindowWidth(window.innerWidth);
  };

  const handleScroll = () => {
    if (window.pageYOffset >= 5) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // Corrected: Use removeEventListener to remove the previously added event listener
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ** Vars
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      const isMobile = windowWidth <= 767;
      const isTablet = windowWidth >= 768 && windowWidth <= 1023;

      setIsMobileView(isMobile);
      setIsTabletView(isTablet);
    };

    handleResize(); // Initial call to set the initial values
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup function to remove the event listener
    };
  }, []);

  //** This function will detect the Route Change and will hide the menu on menu item click
  useEffect(() => {
    if (menuVisibility && windowWidth < 1200) {
      setMenuVisibility(false);
    }
  }, [location]);

  //** Sets Window Size & Layout Props
  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener('resize', handleWindowWidth);
    }
  }, [windowWidth]);

  useEffect(() => {
    if (themeData && themeData?.themeColor) {
      const color = themeData.themeColor;
      const textColor = colorDeepOrLightDetector(color) ? "#fff" : "#000";
      const lightenColor = lightenColorToRgba(color, 0.1);

      document.documentElement.style.setProperty('--theme-color', color);
      document.documentElement.style.setProperty('--theme-text-color', textColor);
      document.documentElement.style.setProperty('--theme-light-color', lightenColor);
    } else {
      document.documentElement.style.setProperty('--theme-color', '#0d6efd');
      document.documentElement.style.setProperty('--theme-text-color', '#fff');
      document.documentElement.style.setProperty('--theme-light-color', '#80b2ff');
    }
  }, [themeData]);

  //** ComponentDidMount
  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  // ** Vars
  const footerClasses = {
    static: 'footer-static',
    sticky: 'footer-fixed',
    hidden: 'footer-hidden'
  };

  if (!isMounted) {
    return null;
  }

  return (
    <div className={classnames()}>
      {isMobile && !isOpenChat && !isOpenBubbleChat && !isOpenDmChat && !isOpenDmBubbleChat &&  <div style={{ position: 'relative', zIndex: 999 }}>
          <TopMobileNav scrolling={scrolling} />
        </div>}
      {!isOpenChat && !isOpenDmChat && <ClientNavbar scrolling={scrolling} />}

      {/* <BackIcon /> */}
      {children}
      {/* Vertical Nav Menu Overlay */}
      <div
        className={classnames('sidenav-overlay', {
          show: menuVisibility
        })}
        onClick={() => setMenuVisibility(false)}
      ></div>
      {/* Vertical Nav Menu Overlay */}

      <>
        {/* <footer
          className={classnames(
            `footer footer-light ${footerClasses[footerType] || 'footer-static'}`,
            {
              'd-none': footerType === 'hidden'
            }
          )}
        >
          {footer ? (
            footer
          ) : (
            <FooterComponent
              footerType={footerType}
              footerClasses={footerClasses}
              isMobileView={isMobileView}
              isTabletView={isTabletView}
            />
          )}
        </footer> */}
        {isMobile && <BottomMobileNav organization={organization} themeData={themeData} />}
        {themeConfig.layout.scrollTop === true ? (
          <div className={`${isMobileView ? 'd-none' : 'scroll-to-top'}`}>
            <ScrollToTop showOffset={300} className="scroll-top d-block">
              <Button className="btn-icon" color="primary">
                <ArrowUp size={14} />
              </Button>
            </ScrollToTop>
          </div>
        ) : null}
      </>
      {/* )} */}
    </div>
  );
};

export default VerticalLayout;
